import { render, staticRenderFns } from "./AutomaticSubmissionAccept.vue?vue&type=template&id=47758410"
import script from "./AutomaticSubmissionAccept.vue?vue&type=script&lang=js"
export * from "./AutomaticSubmissionAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports